/**
 * Master switch for the "lines" atom representation. Lines are disabled in
 * favor of sticks, but the supporting code (style handling, backward-compat
 * detection of existing line styles) is retained so the option can be
 * re-enabled by flipping this flag to true.
 */
export const ALLOW_LINES_REP = false;
export var HydrogenDisplayType;
(function (HydrogenDisplayType) {
    HydrogenDisplayType["All"] = "all";
    HydrogenDisplayType["Polar"] = "polar";
    HydrogenDisplayType["None"] = "none";
})(HydrogenDisplayType || (HydrogenDisplayType = {}));
export var AtomsRepresentation;
(function (AtomsRepresentation) {
    AtomsRepresentation["Hidden"] = "atoms-hidden";
    AtomsRepresentation["Line"] = "line";
    AtomsRepresentation["Stick"] = "stick";
    AtomsRepresentation["Sphere"] = "sphere";
})(AtomsRepresentation || (AtomsRepresentation = {}));
export var BackBoneRepresentation;
(function (BackBoneRepresentation) {
    BackBoneRepresentation["Hidden"] = "backbone-hidden";
    BackBoneRepresentation["Cartoon"] = "cartoon";
})(BackBoneRepresentation || (BackBoneRepresentation = {}));
export var SurfaceRepresentation;
(function (SurfaceRepresentation) {
    SurfaceRepresentation["Hidden"] = "surface-hidden";
    SurfaceRepresentation["Surface"] = "surface";
})(SurfaceRepresentation || (SurfaceRepresentation = {}));
